<template>
  <div class="page-tab member-logs-v2" style="height: 540px">
    <SchemaTablePage
      ref="tablePageRef"
      :form-props="{ labelPosition: 'left' }"
      layout-mode="dialog"
      :immediate="false"
      :search-schema="searchSchema"
      :columns="tableColumns"
      :default-query="defaultQuery"
      :request="request"
      :build-params="buildParams"
      :parse-result="parseResult"
    >
      <template #search-module="{ query }">
        <el-cascader
          v-model="query.modulePath"
          style="width: 100%"
          :options="moduleOptions"
          placeholder="选择操作菜单"
          clearable
          filterable
          separator="-"
          @change="values => (query.module = values?.length ? values.join('-') : '')"
        ></el-cascader>
      </template>

      <template #createdAt="{ row }">{{ row.created_at | formatTimestamp }}</template>
    </SchemaTablePage>
  </div>
</template>

<script>
import { MemberApi } from '@/api/member/member'
import SchemaTablePage from '@/components/SchemaTablePage'
import { formatCurrency } from '@/pages/common/utils'
import { formatTimestamp, toUnixSeconds } from '@/utils/time'

export default {
  name: 'ManageMemberLogsTabV2',
  components: { SchemaTablePage },
  filters: {
    formatTimestamp,
    formatChangeString(str) {
      if (!str) return ''
      const numbers = str.match(/\\d+(\\.\\d+)?/g)
      if (numbers && numbers.length > 0) {
        const amount = numbers[0]
        const amountCurrency = formatCurrency(amount)
        return str.replace(numbers[0], amountCurrency)
      }
      return str
    },
  },
  props: {
    resetKey: { type: Number, default: 0 },
    targetInfo: { type: Object, default: () => ({}) },
    isActive: { type: Boolean, default: false },
  },
  data() {
    return {
      moduleOptions: [
        {
          value: '代理管理',
          label: '代理管理',
          children: [
            {
              value: '代理列表',
              label: '代理列表',
              children: [
                { value: '新增代理', label: '新增代理' },
                { value: '编辑代理', label: '编辑代理' },
              ],
            },
          ],
        },
        {
          value: '会员管理',
          label: '会员管理',
          children: [
            {
              value: '账户管理',
              label: '账户管理',
              children: [{ value: '新增账户', label: '新增账户' }],
            },
            {
              value: '会员列表',
              label: '会员列表',
              children: [
                { value: '重置玩家支付密码', label: '重置玩家支付密码' },
                { value: '禁用玩家', label: '禁用玩家' },
                { value: '启用玩家', label: '启用玩家' },
                { value: '设置玩家RTP', label: '设置玩家RTP' },
                { value: '修改玩家密码', label: '修改玩家密码' },
                {
                  value: '账户调整',
                  label: '账户调整',
                  children: [
                    { value: '系统调整', label: '系统调整' },
                    { value: '输赢调整', label: '输赢调整' },
                  ],
                },
              ],
            },
          ],
        },
        {
          value: '风控管理',
          label: '风控管理',
          children: [
            {
              value: '登录日志',
              label: '登录日志',
              children: [
                { value: 'ip黑名单禁用玩家', label: 'ip黑名单禁用玩家' },
                { value: '设备黑名单禁用玩家', label: '设备黑名单禁用玩家' },
              ],
            },
          ],
        },
      ],
      defaultQuery: {
        memberNo: '',
        username: '',
        module: '',
        modulePath: [],
        operationDateRange: [],
      },
      searchSchema: [
        {
          prop: 'username',
          label: '操作人',
          component: 'input',
          componentProps: { clearable: true },
        },
        {
          label: '操作菜单',
          component: 'slot',
          slot: 'search-module',
        },
        {
          prop: 'operationDateRange',
          label: '操作时间',
          component: 'datetime-range',
          componentProps: { clearable: true },
          span: { xs: 24, sm: 12, md: 16, lg: 7, xl: 6 },
        },
        { component: 'actions', span: { lg: 4 } },
      ],
      tableColumns: [
        { resizable: false, prop: 'target_name', label: '会员账号', width: 100 },
        { resizable: false, prop: 'module', label: '操作菜单', minWidth: 140 },
        { resizable: false, prop: 'server_desc', label: '操作内容', minWidth: 160 },
        { resizable: false, prop: 'before', label: '修改前', minWidth: 180 },
        { resizable: false, prop: 'after', label: '修改后', minWidth: 180 },
        { resizable: false, prop: 'username', label: '操作人', width: 100 },
        { resizable: false, prop: 'created_at', label: '最后操作时间', width: 140, slot: 'createdAt' },
      ],
    }
  },
  computed: {
    request() {
      return params => MemberApi.getMemberLogList(params)
    },
    buildParams() {
      return ({ query, page, limit }) => {
        const params = {
          page,
          page_size: limit,
          target_name: query?.memberNo || this.targetInfo?.username || '',
          username: query?.username || '',
        }
        if (query?.module) params.module = query.module
        if (query?.operationDateRange?.length === 2) {
          params.start_at = toUnixSeconds(query.operationDateRange[0])
          params.end_at = toUnixSeconds(query.operationDateRange[1])
        }
        return params
      }
    },
    parseResult() {
      return res => {
        if (res && res.code === 0) {
          return { list: res.data?.list || [], total: res.data?.total || 0 }
        }
        this.$message.error(res?.msg || res?.message || '加载会员日志列表失败')
        return { list: [], total: 0 }
      }
    },
  },
  mounted() {
    this.$nextTick(() => this.$refs.tablePageRef?.reload?.())
  },
  watch: {
    resetKey() {
      this.$nextTick(() => this.$refs.tablePageRef?.reset?.())
    },
  },
}
</script>

<style scoped>
.log-content {
  max-height: 60px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-clamp: 3;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  word-break: break-all;
}

.pagination-container {
  margin-top: 15px;
  text-align: right;
}
</style>
